import {
  CLEAR_SINGLE_APPLICATION_DATA,
  ERROR,
  GET_APPLICATION_STATUS_LIST,
  GET_APPLICATIONS,
  GET_APPLICATIONS_SUMMARY_VIEWS,
  GET_AUDIT_TRAIL_FOR_APPLICATION,
  GET_BORROWER_OCR_DOCS,
  GET_COBORROWER_OCR_DOCS,
  GET_DELETED_APPLICATIONS,
  GET_LOANS,
  GET_SINGLE_APPLICATION,
  LOADER,
  RESET_APPLICATION_DATA,
  SET_COBORROWER_DOC_ERROR,
  SET_COBORROWER_DOC_LOADING,
  SET_COBORROWER_DOC_SUCCESS,
  SET_CURRENT_APPLICATION_ID,
  SET_DOC_ERROR,
  SET_DOC_LOADING,
  SET_DOC_SUCCESS,
  GET_POST_SANCTION_DOCUMENT_PROCESSING_QUEUE,
  SET_DOCUMENT_URL
} from "../actionType";

let initialState = {
  loading: false,
  error: null,
  applications: [],
  singleApplication: null,
  currentApplicationId: null,
  applicationStatusList: [],
  loans: [],
  documentUrls: {},
  // ocrDocsLoading: false,
  // borrowerOCRDocs: { cbReport: null, aadharCard: null, panCard: null, voterId: null, drivingLicense: null, otherKyc: null },
  // coborrowerOCRDocs: { cbReport: null, aadharCard: null, panCard: null, voterId: null, drivingLicense: null, otherKyc: null },
  // ocrDocsError: false,
  borrowerOCRDocs: {
    data: {
      cbReport: null,
      aadharCard: null,
      panCard: null,
      voterId: null,
      drivingLicense: null,
      otherKyc: null
    },
    loading: {
      cbReport: false,
      aadharCard: false,
      panCard: false,
      voterId: false,
      drivingLicense: false,
      otherKyc: false
    },
    error: {
      cbReport: null,
      aadharCard: null,
      panCard: null,
      voterId: null,
      drivingLicense: null,
      otherKyc: null
    }
  },
  coborrowerOCRDocs: {
    data: {
      cbReport: null,
      aadharCard: null,
      panCard: null,
      voterId: null,
      drivingLicense: null,
      otherKyc: null
    },
    loading: {
      cbReport: false,
      aadharCard: false,
      panCard: false,
      voterId: false,
      drivingLicense: false,
      otherKyc: false
    },
    error: {
      cbReport: null,
      aadharCard: null,
      panCard: null,
      voterId: null,
      drivingLicense: null,
      otherKyc: null
    }
  },
  auditTrail: {},
  applicationsSummary: [],
  deletedApplications: {},
  postSanctionDocumentProcessingQueue: {}
};

export const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOADER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case GET_SINGLE_APPLICATION:
      return {
        ...state,
        loading: false,
        singleApplication: payload,
        error: null,
      };
    case GET_APPLICATIONS:
      return {
        ...state,
        loading: false,
        applications: { data: [...payload.applications], pagination: payload.pagination, summaryCount: payload.summary_count },
        // applications: { data: [...payload.data] },
        error: null,
      };
    case SET_CURRENT_APPLICATION_ID:
      return { ...state, currentApplicationId: payload };
    case CLEAR_SINGLE_APPLICATION_DATA:
      return {
        ...state,
        singleApplication: null,
        // currentApplicationId is intentionally left untouched here —
        // Home.js's setCurrentApplicationId(applicationId) effect already
        // keeps it correct on every applicationId change (and runs before
        // this one fires), so nulling it here only broke components that
        // read currentApplicationId directly (e.g. SupplierDetails.jsx's
        // fetch guard) without ever being restored afterward.
        //
        // Otherwise a previously-opened application's loans (e.g.
        // loans.data.length > 0) leak into the next application's first
        // render, before its own GET_LOANS fetch resolves - see
        // Disbursement.jsx's Create Loan button disabled check.
        loans: []
      };
    case GET_APPLICATION_STATUS_LIST:
      return {
        ...state,
        loading: false,
        applicationStatusList: payload,
        error: null,
      };
    case GET_LOANS:
      return {
        ...state,
        loans: { data: [...payload.data], pagination: payload.pagination },
      };
    // case GET_BORROWER_OCR_DOCS:
    //     return {
    //         ...state,
    //         ocrDocsLoading: false,
    //         borrowerOCRDocs: payload,
    //         ocrDocsError: false
    //     };
    // case GET_COBORROWER_OCR_DOCS:
    //     return {
    //         ...state,
    //         ocrDocsLoading: false,
    //         coborrowerOCRDocs: payload,
    //         ocrDocsError: false
    //     };




    case SET_COBORROWER_DOC_LOADING:
      return {
        ...state,
        coborrowerOCRDocs: {
          ...state.coborrowerOCRDocs,
          loading: {
            ...state.coborrowerOCRDocs.loading,
            [payload.docKey]: true
          },
          error: {
            ...state.coborrowerOCRDocs.error,
            [payload.docKey]: null
          }
        }
      };

    case SET_COBORROWER_DOC_SUCCESS:
      return {
        ...state,
        coborrowerOCRDocs: {
          ...state.coborrowerOCRDocs,
          data: {
            ...state.coborrowerOCRDocs.data,
            [payload.docKey]: payload.docData
          },
          loading: {
            ...state.coborrowerOCRDocs.loading,
            [payload.docKey]: false
          }
        }
      };

    case SET_COBORROWER_DOC_ERROR:
      return {
        ...state,
        coborrowerOCRDocs: {
          ...state.coborrowerOCRDocs,
          loading: {
            ...state.coborrowerOCRDocs.loading,
            [payload.docKey]: false
          },
          error: {
            ...state.coborrowerOCRDocs.error,
            [payload.docKey]: payload.error
          }
        }
      };



    case SET_DOC_LOADING:
      return {
        ...state,
        [payload.applicant + 'OCRDocs']: {
          ...state[payload.applicant + 'OCRDocs'],
          loading: {
            ...state[payload.applicant + 'OCRDocs'].loading,
            [payload.docKey]: true
          },
          error: {
            ...state[payload.applicant + 'OCRDocs'].error,
            [payload.docKey]: null
          }
        }
      };

    case SET_DOC_SUCCESS:
      return {
        ...state,
        [payload.applicant + 'OCRDocs']: {
          ...state[payload.applicant + 'OCRDocs'],
          data: {
            ...state[payload.applicant + 'OCRDocs'].data,
            [payload.docKey]: payload.docData
          },
          loading: {
            ...state[payload.applicant + 'OCRDocs'].loading,
            [payload.docKey]: false
          }
        }
      };

    case SET_DOC_ERROR:
      return {
        ...state,
        [payload.applicant + 'OCRDocs']: {
          ...state[payload.applicant + 'OCRDocs'],
          loading: {
            ...state[payload.applicant + 'OCRDocs'].loading,
            [payload.docKey]: false
          },
          error: {
            ...state[payload.applicant + 'OCRDocs'].error,
            [payload.docKey]: payload.error
          }
        }
      };
    case GET_AUDIT_TRAIL_FOR_APPLICATION:
      return {
        ...state,
        auditTrail: { history: payload.history, pagination: payload.pagination, grouped_by: payload.grouped_by, category_counts: payload.category_counts }
      }

    case GET_APPLICATIONS_SUMMARY_VIEWS:
      return {
        ...state,
        loading: false,
        applicationsSummary: payload,
        error: null,
      };
    case GET_DELETED_APPLICATIONS:
      return {
        ...state,
        loading: false,
        deletedApplications: { data: payload.applications, pagination: payload.pagination },
        error: null
      }

    case GET_POST_SANCTION_DOCUMENT_PROCESSING_QUEUE:
      return {
        ...state,
        loading: false,
        postSanctionDocumentProcessingQueue: { data: payload.data, pagination: payload.pagination },
        error: null
      }
    case SET_DOCUMENT_URL:
      return {
        ...state,
        documentUrls: {
          ...state.documentUrls,
          [payload.documentId]: { url: payload.url, fetchedAt: payload.fetchedAt }
        }
      };
    default:
      return state;
  }
};
